import {CallApi} from "./ApiCommon";
import {ApiRequestError} from "./ApiRequestError";
import {MyBabyInfo} from "./response/MyBaby";

export const GetMyBabyList = async (): Promise<MyBabyInfo[]> => {
  try {
    const result = await CallApi("/api_user/my_baby", {
      credentials: "include",
    });
    return result.data as MyBabyInfo[];
  } catch (e: any) {
    if (e instanceof ApiRequestError) throw e;
    throw new ApiRequestError(e.message);
  }
};
